<template>
<div class="c-app flex-row content-center align-items-center">
  <CContainer >
    <CRow  class="justify-content-center"  v-if="data.success === ''">
      <CCol md="8">
        <CCardGroup class="mt-5">
          <CCard class="p-3">
            <CCardBody>
              <form class="login" @submit.prevent="changePassword">
                <h1>Forgot Your Password</h1>
                <br>

                <CInput
                  placeholder="Email"
                  autocomplete="username email"
                  v-model="data.email" type="email"
                  required
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>

                <hr>
                <CRow>
                  <CCol  class="text-left">
                    <p class="text-danger" v-if="data.error">{{ data.error }}</p>
                    <CButton block type="submit" color="info" class="mt-3" v-on:click.prevent="update()">Forgot Password</CButton>
                  </CCol>
                  
                </CRow>
              </form>
            </CCardBody> 
          </CCard>
          
        </CCardGroup>
      </CCol>
    </CRow>
    <CRow v-else>
      <div>
        {{ data.message }}
        <br><CButton color="link" class="px-0" @click="login">back to Login</CButton> 
      </div>
    </CRow>
  </CContainer>
</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import user from '@/services/user'

export default {
  

    data(){
        return{
            data: {
                email: '',
                id:'',
                password: '',
                password_confirmation: '',
                remember_me: false,
                message: '',
                error: '',
                success:''
            },
        }
    },
    created() {

    },
    computed: {

    },
    methods: {
      update(){
        user.forgotpassword(this.data)
        .then(res => {
          console.log(res.message)
          //if(res.message = 'set password success'){
            this.data.success = 'success'
            this.data.message = 'confirmation code send to your email'
          //}
        }).catch ((err) => {
          console.log(err.response.data.message)
          if(err.response.data.message = 'wrong email'){
            this.data.error = err.response.data.message
          }
        })
      }, 
      login(){  
         this.$router.push({name:'Login'})          
      },     
    }
}
</script>
